import React, { useEffect, useState} from "react";
import ParameterSwitch from 'components/controls/ParameterSwitch';
import {BlankSeparator} from 'components/controls/Separators';
import InfoTooltip from 'components/controls/InfoTooltip';
import { useTranslation } from 'react-i18next';


export default function ParametersMenu(props) {
  const { t } = useTranslation();

  useEffect(() => { 
    console.log('render ParametersMenu')
  });


  return (
    <div className="menuContainer">
      <p className="menuTitle"><InfoTooltip title={t('menu.universe.info.title')} body={t('menu.universe.info.body')} /> {t('menu.universe.title')}</p>
      <ParameterSwitch />
    </div>
  )
}